import React, { createContext, useContext, useState } from 'react';
import { toast } from 'react-toastify'; //? React-Toastify

const DarkModeContext = createContext(null);

export const DarkModeProvider = ({ children }) => {
  const [mode, setMode] = useState('light');

  const ToggleMode = () => {
    if (mode === 'light') {
      setMode('dark');
      document.body.style.backgroundColor = '#042743';
      document.body.style.color = 'white';
      toast.info('Dark Mode ON');
    } else {
      setMode('light');
      document.body.style.backgroundColor = 'white';
      document.body.style.color = '#042743';
      toast.info('Dark Mode OFF');
    }
  };

  //////////////////////////////////////////////////////////////
  return <DarkModeContext.Provider value={{ ToggleMode, mode }}>{children}</DarkModeContext.Provider>;
};

export const DarkMode = () => useContext(DarkModeContext);
